import OnlineRenewalPurchaseRenewal from '@/components/OnlineRenewalPurchaseRenewal.vue'

export default {
    components: {
        OnlineRenewalPurchaseRenewal
    },
    data() {
        return {
        }
    },
    props: {
        policyExpiry: String,
        paymentTerms: String,
        totalPayable: String,
        summaryData: Array,
        premiumBreakdownData: Array,
        policyHolderInformationData: Array,
        eligibleForRenewal: Boolean
    },
    computed: {
        policyExpiryFormatted() {
            return moment(this.policyExpiry, 'YYYY-MM-DD').format('Do MMM YYYY');
        },
        monthlyPayment() {
            return (Number(this.totalPayable) / 12).toFixed(2);
        },
        fortnightlyPayment() {
            return (Number(this.totalPayable) / 24).toFixed(2);
        }
    },
    methods: {
        setTablesData() {
            setTimeout(() => {
                let summaryTable = document.getElementById('summary-table'),
                policyHolderInformationTable = document.getElementById('policy-holder-information-table'),
                premiumBreakdownTable = document.getElementById('premium-breakdown-table');

                summaryTable.tableData = this.summaryData;
                policyHolderInformationTable.tableData = this.policyHolderInformationData;
                premiumBreakdownTable.tableData = this.premiumBreakdownData;
            }, 1000);
        }
    },
    mounted() {
        this.setTablesData();
    }
}